import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'newcomplaint/complaintResolution';

const complaintResolutionService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default complaintResolutionService;
